import CoordinatorListItems from "../components/CoordinatorListItems";

import "../styles/CoordinatorConsole.css";

export default function CoordinatorConsole() {
  return (
    <main className="coordinatorConsolePage">
      <CoordinatorListItems />
    </main>
  );
}